/**
 * Semantic colour mapping for entity types used by the case-report mini previews.
 *
 * Returns a Tailwind text-* utility so the caller can apply it to an SVG element
 * and read it via ``fill="currentColor"`` / ``stroke="currentColor"``. We avoid
 * hardcoded colours and route everything through the project theme tokens.
 */
export function entityColorClass(label: string | null | undefined): string {
  if (!label) return 'text-muted-foreground'
  if (PERSON_LABELS.has(label)) return 'text-primary'
  if (ORG_LABELS.has(label)) return 'text-info'
  if (DOC_LABELS.has(label)) return 'text-muted-foreground'
  if (GEO_LABELS.has(label)) return 'text-success'
  if (CONTACT_LABELS.has(label)) return 'text-warning'
  if (MONEY_LABELS.has(label)) return 'text-destructive'
  return 'text-foreground/70'
}

const PERSON_LABELS = new Set(['Person'])
const ORG_LABELS = new Set(['Company', 'Organization', 'BankAccount', 'ExchangeAccount'])
const DOC_LABELS = new Set(['Document', 'CaseDocument'])
const GEO_LABELS = new Set([
  'Location',
  'Address',
  'GeoObservation',
  'BTSStation',
  'Vessel',
  'Aircraft',
  'Drone',
])
const CONTACT_LABELS = new Set([
  'PhoneNumber',
  'Phone',
  'Email',
  'EmailAddress',
  'MobileDevice',
  'IdentificationDocument',
  'Vehicle',
])
const MONEY_LABELS = new Set(['Transaction', 'BankTransaction', 'BlockchainAddress', 'Cluster'])
